import { getJson } from '../../../../shared/api/httpClient';
import config from '../../../../configs/config';

export function fetchManualResetInfo(idAgent) {
  return getJson('UserResetPwdMarivalManual', { Type: 1, id_Agent: idAgent, Brand: config.emailBrand }, {
    errorMessage: 'Restore password manual request failed'
  });
}

export function resetPasswordManual({ idAgent, newPassword, urlCode }) {
  return getJson('UserResetPwdMarivalManual', {
    Type: 2,
    id_Agent: idAgent,
    NewPassword: newPassword,
    ConfirmEmailUrlCode: urlCode,
    Brand: config.emailBrand
  }, {
    errorMessage: 'Restore password manual request failed'
  });
}
